import React from 'react';
import { useDispatch } from 'react-redux';
import CheckoutSection from './utils/Checkout.Section';
import CheckoutSectionContent from './utils/Checkout.SectionContent';
import { translate } from '../../Services/translation';
import useDebouncedOnChange from '../../Hooks/useDebouncedOnChange';
import { setOrderNote as setOrderNoteAction } from '../../Actions/Checkout.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import styled from 'styled-components';
import { text } from '../../styling/mixins/typography';
import TextArea from '../Inputs/TextArea';

const StyledCheckoutSection = styled(CheckoutSection)`
  margin-bottom: 0.8rem;

  .description {
    ${text('large')}
    margin-bottom: 1.6rem;
  }
`;

const AdditionalOrderInfo = () => {
  const dispatch = useDispatch();
  const checkout = useTypedSelector((state) => state.checkout);
  const { customerServiceMessage } = checkout.payload;
  const [comments, setOrderNote] = useDebouncedOnChange('', () =>
    dispatch(setOrderNoteAction(comments))
  );

  return (
    <StyledCheckoutSection title={translate('checkout.additionalinfo.title')}>
      <CheckoutSectionContent>
        {customerServiceMessage && (
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: customerServiceMessage.value,
            }}
          ></div>
        )}
        <TextArea
          inputSize="xlarge"
          label={translate('checkout.order.message')}
          id="additional-info__input"
          placeholder={translate('checkout.ordernote.placeholder')}
          onChange={(e) => setOrderNote(e.target.value)}
        />
      </CheckoutSectionContent>
    </StyledCheckoutSection>
  );
};

export default AdditionalOrderInfo;
